import React, { useEffect, useRef, useState, useCallback } from "react";
import styles from "./styles.module.scss";

const SlidingRadioInput = ({ options, onChange, selected }) => {
  const tabRefs = useRef([]);
  const [activeOption, setActiveOption] = useState(
    typeof selected === "object" && selected?.value
      ? selected?.value
      : (selected ?? options[0].value),
  );
  const [activeOptionStyle, setActiveOptionStyle] = useState({
    left: "0px",
    width: "0px",
  });

  useEffect(() => {
    const updateIndicator = () => {
      const activeTab =
        tabRefs.current[options.findIndex((tab) => tab.value === activeOption)];
      if (activeTab) {
        setActiveOptionStyle({
          left: `${activeTab.offsetLeft}px`,
          width: `${activeTab.offsetWidth}px`,
        });
      }
    };

    updateIndicator();
    window.addEventListener("resize", updateIndicator);

    return () => window.removeEventListener("resize", updateIndicator);
  }, [activeOption, options]);

  const handleTabClick = (tab) => {
    setActiveOption(tab.value);
    if (onChange) onChange(tab.value);
  };

  return (
    <div className={styles.tabContainer}>
      <div className={styles.tabList}>
        {options.map((tab, index) => (
          <button
            type="button"
            key={tab.value}
            className={`${styles.tab} ${activeOption == tab.value ? styles.activeTab : ""}`}
            onClick={() => handleTabClick(tab)}
            ref={(el) => (tabRefs.current[index] = el)}
          >
            {tab.label}
          </button>
        ))}
        <div className={styles.activeBackground} style={activeOptionStyle} />
      </div>
    </div>
  );
};

export default SlidingRadioInput;
